import React from 'react';
import classNames from 'classnames';

import { BlockerIcon, InfoIcon } from 'components/Icons';

import styles from './Notification.module.scss';

export enum NotificationType {
  Alert = 'Alert',
  Info = 'Info',
}

interface NotificationProps {
  message: string;
  type: NotificationType;
}

const iconByTypeMap = new Map<NotificationType, JSX.Element>([
  [NotificationType.Info, <InfoIcon width={21} height={21} />],
  [NotificationType.Alert, <BlockerIcon width={22} height={20} />],
]);

const Notification = ({ message, type }: NotificationProps) => {
  const notificationBoxStyle = classNames({
    [styles.alert_notification_box]: type === NotificationType.Alert,
    [styles.info_notification_box]: type === NotificationType.Info,
  });

  return (
    <>
      <div className={notificationBoxStyle}>{iconByTypeMap.get(type)}</div>
      <div className={styles.message_container}>{message}</div>
    </>
  );
};

export default Notification;
